<script>
  import { CarouselItem } from 'element-ui'
  export default {
    name:'ElCarouselItem',
    extends:CarouselItem
  }
</script>
